import { EncryptStorage } from 'encrypt-storage'
const encryptStorage = new EncryptStorage(process.env.VUE_PERSIST_SECRET_KEY)

export const vuePersistWriteToLocalStorage = (key, val) => {
  encryptStorage.setItem(key, val)
}

export const vuePersistReadToLocalStorage = (key) => {
  try {
    // If localStorage data old version store plain text
    const tempData = localStorage.getItem(key)
    const tempDataObj = JSON.parse(tempData)

    if (typeof tempDataObj === 'object') {
      return tempData
    }
  } catch (error) {
    // If localStorage encryption data
    const value = encryptStorage.getItem(key)
    return JSON.stringify(value)
  }
}



// WEBPACK FOOTER //
// ./src/utils/vuePersist.js